import { customFieldsPayload } from "components/BaseForm";

const isFilled = value => value.trim() !== "";

const toPayloadEmail = ({ id, email, is_primary, enabled, subscribed }) => ({
  ...(id != null && { id }),
  email: email.trim(),
  is_primary,
  enabled,
  subscribed,
});

const toPayloadPhone = ({
  id,
  number,
  ext,
  type,
  is_primary,
  is_callable,
  enabled,
}) => ({
  ...(id != null && { id }),
  number: number.trim(),
  ext: ext.trim(),
  type,
  is_primary,
  is_callable,
  enabled,
});

/**
 * Form values as the create and update request body. Empty email and phone
 * rows are dropped. The entity travels in the URL, not the body.
 *
 * The preset fields link a new contact to where it was created from. An edit
 * passes an empty preset, and the service drops nil fields from the body.
 */
export const toContactPayload = (
  values,
  { customFieldConfigs, preset = {} }
) => ({
  full_name: values.full_name.trim(),
  preferred_name: values.preferred_name.trim(),
  title: values.title.trim(),
  department_id: values.department_id ?? null,
  email_addresses: values.email_addresses
    .filter(row => isFilled(row.email))
    .map(toPayloadEmail),
  phone_numbers: values.phone_numbers
    .filter(row => isFilled(row.number))
    .map(toPayloadPhone),
  alternate_names: values.alternate_names
    .map(name => name.trim())
    .filter(Boolean)
    .map(name => ({ name })),
  tags: values.tags,
  custom_fields: customFieldsPayload(customFieldConfigs, values.custom_fields),
  campaign_id: preset.campaignId,
  lead_id: preset.leadId,
  lead_source: preset.leadSource,
  lead_source_record_id: preset.leadSourceRecordId,
});
